const App = () => {
	return (
		<div className="container">
			<h2>hello react</h2>
		</div>
	);
};

export default App;